import { useTheme } from "context/AntdThemeContext"
import { resolveAssistant } from "config/assistants"

/**
 * The AI Assistant persona for the active theme — Earl on Sportsman, Ruth on Sportswoman.
 *
 * Reads the theme rather than the user record so the assistant always matches the branding
 * around it, including the cases where the theme is not the logged-in user's own preference
 * (the `?ds-theme=` query param, and viewing a guide's public profile, both call
 * `switchTheme`).
 */
export const useAssistantPersona = () => {
  const { theme } = useTheme()

  return resolveAssistant({ preference: null, theme })
}

export default useAssistantPersona
